/* Almla redesign: collection page. The Cortex Page Builder collection design's
   renderer, kept close to the original. window.ALMLA is built by
   sections/alm-collection.liquid from the live collection instead of the
   design's static snapshot. Changes from the design: same-tab links, real
   variant ids and cents for the cart, the "coming soon" lines come from a
   section setting, sold-out cards say Notify Me When Back and open the product
   page, where the Klaviyo Back in Stock form actually captures the email, and a collection URL preselects its tile. */

/* One page (client feedback, Oct 13: "clicking next hurts conversion"): every
   product of the filtered list shows at once, photos lazy-loaded. For SEO the
   server still prints a plain link to every product (and ?page=N links past
   Shopify's 250 per page). The full collection arrives from window.ALMLA_LOAD
   (sections/alm-collection.liquid, templates/collection.alm-data.liquid) so
   filters, sort and search cover everything. If the data never arrives, the
   server's own list of links stays as it is. */
(function(){
  var D = window.ALMLA;
  if (!D) return;
  var load = window.ALMLA_LOAD || Promise.resolve([]);
  load.then(function(rows){
    D.products = (rows || []).map(shape);
    try { if (D.products.length) run(); }
    finally { document.documentElement.classList.remove("alm-col-wait"); }
  }, function(){ /* keep the server-rendered page */ });

  // Section-specific fields from each product's collection handles, exactly as
  // the section used to work them out in Liquid.
  function shape(r){
    var H = r.h || [], cat = H.indexOf(D.bundleHandle) > -1 ? "Bundles" : "Socks", th = [];
    var h = (r.u || "").split("/products/")[1] || "";
    (D.collections || []).forEach(function(c){
      if (H.indexOf(c.h) === -1) return;
      if (c.k === "cat") cat = c.t; else th.push(c.t);
    });
    var p = { t:r.t, v:r.v, p:r.p, u:r.u, i:r.i, i2:r.i2, cat:cat, th:th,
      n: H.indexOf(D.newHandle) > -1, b: H.indexOf(D.bestHandle) > -1, k: H.indexOf(D.bundleHandle) > -1,
      // Best Seller tag: only the top of the list (snippets/alm-best-top.liquid).
      bt: (D.bestTop || []).indexOf(h) > -1, back: H.indexOf(D.backHandle || "back-in-stock") > -1,
      gc: !!r.gc, im: r.im || [], own: "",
      s:r.s, off:r.off, sz: cat === "Socks" && r.d ? "One Size Fits All" : "",
      c:r.c, c2:r.c2, pat:r.pat, cf:r.cf };
    // A style with no strip tile groups with its own collection (Earn Your
    // Stripes, In My Element) rather than with every other untiled product.
    var generic = ["shop-all", "all", D.newHandle, D.bestHandle, D.bundleHandle, D.backHandle || "back-in-stock"];
    H.forEach(function(x, j){ if (!p.own && generic.indexOf(x) === -1 && r.ct && r.ct[j]) p.own = r.ct[j]; });
    // Colour and pattern from the curated map where no metafield is set.
    var F = (window.ALM_FACETS || {})[(p.u || "").split("/products/")[1]] || {}, known = {};
    (window.ALM_COLORS || []).forEach(function(c){ known[c[0]] = 1; });
    p.c = p.c || F.c || "multi"; if (!known[p.c]) p.c = "multi";
    p.c2 = p.c2 || F.c2 || ""; if (!p.c2 || !known[p.c2]) delete p.c2;
    // A third colour (client's colour sheet, Oct 14: e.g. Multi on prints).
    p.c3 = F.c3 || ""; if (!p.c3 || !known[p.c3]) delete p.c3;
    p.pat = p.pat || F.pat || "";
    if (!p.cf || !p.cf.length) p.cf = F.cf || [];
    return p;
  }

  function run(){
  var P = D.products, COLORS = D.colors, PATTERNS = D.patterns, CATS = D.cats;

  // Client merge: white folds into cream, peach into orange, navy into blue.
  // Remap every product colour before anything reads it, then drop the three
  // absorbed swatches so the filter shows one entry per merged colour.
  var CMERGE = { peach:"orange", navy:"blue" };
  P.forEach(function(p){
    if (p.c && CMERGE[p.c]) p.c = CMERGE[p.c];
    if (p.c2 && CMERGE[p.c2]) p.c2 = CMERGE[p.c2];
    if (p.c2 === p.c) delete p.c2;
    if (p.c3 && CMERGE[p.c3]) p.c3 = CMERGE[p.c3];
    if (p.c3 === p.c || p.c3 === p.c2) delete p.c3;
  });
  COLORS = COLORS.filter(function(c){ return !CMERGE[c[0]]; });

  var catN = {}, subN = {};
  P.forEach(function(p){
    if (!p.cat) return;
    catN[p.cat] = (catN[p.cat]||0)+1;
    subN[p.cat] = subN[p.cat] || {};
    p.th.forEach(function(t){ subN[p.cat][t] = (subN[p.cat][t]||0)+1; });
  });
  function subsOf(c){
    var o = subN[c] || {};
    return Object.keys(o).sort(function(a,b){ return o[b]-o[a] || a.localeCompare(b); });
  }
  var cc = {};
  // Gift cards have no colour, so they never count towards (or show under) a colour.
  P.forEach(function(p){ if (p.gc) return; cc[p.c] = (cc[p.c]||0)+1; if (p.c2) cc[p.c2] = (cc[p.c2]||0)+1; if (p.c3) cc[p.c3] = (cc[p.c3]||0)+1; if (p.pat) cc[p.pat] = (cc[p.pat]||0)+1; });
  var CMAP = {}; COLORS.forEach(function(c){ CMAP[c[0]] = c; });
  var PMAP = {}; PATTERNS.forEach(function(c){ PMAP[c[0]] = c; });
  // Cuff styles (crew / ruffle / scallop): client request, Oct 5.
  var CUFFS = D.cuffs || [], FMAP = {}; CUFFS.forEach(function(c){ FMAP[c[0]] = c; });

  var S = { q:"", colors:{}, pats:{}, themes:{}, cats:{}, flags:{}, cuffs:{} };
  P.forEach(function(p, i){ p._i = i; });
  // Variant bubbles: the other styles in the same collection. A card's group is
  // its first collection, so Best Furry Friends shows the other pets. A hat or
  // tote groups with its category tile first (client feedback, Oct 13: the
  // Goldendoodle hat showed pet socks, not hats). assets/alm-cards.js and
  // snippets/alm-card.liquid follow the same rule.
  var GROUP = {}, CATTILE = {};
  (D.collections || []).forEach(function(c){ if (c.k === "cat") CATTILE[c.t] = 1; });
  // Gift cards never group (client feedback, Oct 13: the gift card showed as a
  // style of Earn Your Stripes, because both fell back to the "Socks" group).
  // Style groups keep a fixed priority so reordering the tiles above the grid
  // never changes which bubbles a style shows (same order as the card and
  // product page "Style group collections" lists).
  var GORDER = ["Neutrals","Pets","Cocktails","Fruits","Milestones","Coastal","Bamboo Non-Grip","Patterned","Collaborations"];
  function firstTheme(th){ for (var i = 0; i < GORDER.length; i++) if (th.indexOf(GORDER[i]) > -1) return GORDER[i]; return th[0]; }
  function groupOf(p){ if (p.gc) return ""; if (CATTILE[p.cat]) return p.cat; return firstTheme(p.th) || (p.cat !== "Socks" ? p.cat : p.own) || ""; }
  P.forEach(function(p){ var g = groupOf(p); if (!g) return; (GROUP[g] = GROUP[g] || []).push(p); });
  function sibs(g){ return (GROUP[g] || []).slice().sort(function(a,b){ return (!!a.s) - (!!b.s); }); }
  function keys(o){ return Object.keys(o).filter(function(k){ return o[k]; }); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(m){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[m]; }); }
  function money(v){ return "$" + v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function q(sel){ return document.querySelector(sel); }

  function match(p){
    var cs = keys(S.colors), ps = keys(S.pats), ts = keys(S.themes), gs = keys(S.cats);
    if (gs.length && gs.indexOf(p.cat) === -1) return false;
    // The label buttons above the grid (New, Best Seller, Bundle, Sold Out, ...)
    // filter too; picking two shows styles carrying either label.
    var fs = keys(S.flags);
    if (fs.length && !fs.some(function(f){ return FLAG_TEST[f](p); })) return false;
    // Color and pattern are separate questions now: a shopper picking Cream and
    // Blue wants both colors, not every striped sock as well.
    // A two-tone style carries a second colour in c2 and answers to either, so
    // picking Cream stops returning a sock the shopper would call grey.
    if (cs.length && p.gc) return false;
    if (cs.length && cs.indexOf(p.c) === -1 && (!p.c2 || cs.indexOf(p.c2) === -1) && (!p.c3 || cs.indexOf(p.c3) === -1)) return false;
    if (ps.length && (!p.pat || ps.indexOf(p.pat) === -1)) return false;
    var fs2 = keys(S.cuffs);
    if (fs2.length && !(p.cf || []).some(function(c){ return fs2.indexOf(c) > -1; })) return false;
    if (ts.length && !p.th.some(function(t){ return ts.indexOf(t) > -1; })) return false;
    if (S.q){
      var hay = (p.t + " " + p.cat + " " + p.th.join(" ") + " " + CMAP[p.c][1] +
        (p.c2 && CMAP[p.c2] ? " " + CMAP[p.c2][1] : "") +
        (p.pat ? " " + PMAP[p.pat][1] : "") + " " + (p.cf || []).join(" ")).toLowerCase();
      if (hay.indexOf(S.q) === -1) return false;
    }
    return true;
  }

  // One tag per card (client, Oct 13: only New, Back in Stock and Best Seller
  // exist, New first), plus Sold Out, which is a state rather than a tag.
  // The Best Seller and Back in Stock filters show exactly the styles that can
  // carry that tag (client, Oct 13: the whole Best Sellers collection showed
  // Lemon, Strawberry and the Doodle hat).
  var FLAG_TEST = {
    "new": function(p){ return !!p.n; }, best: function(p){ return !!p.bt; },
    bundle: function(p){ return !!p.k || p.cat === "Bundles"; }, out: function(p){ return !!p.s; }, instock: function(p){ return !p.s; },
    back: function(p){ return !!p.back && !p.s; }, sale: function(p){ return !!p.off; }
  };
  var FLAG_NAME = { "new":"New", best:"Best Seller", bundle:"Bundle", out:"Sold Out", instock:"In Stock", back:"Back in Stock", sale:"SALE" };
  function tag(p){ return p.n ? "New" : p.back && !p.s ? "Back in Stock" : p.bt ? "Best Seller" : ""; }
  function flags(p){
    var out = [], t = tag(p);
    if (t) out.push('<span class="flag' + (p.n ? " is-new" : "") + '">' + t + '</span>');
    if (p.s) out.push('<span class="flag is-out">Sold Out</span>');
    return out.length ? '<span class="flags">' + out.join("") + '</span>' : "";
  }
  // Back in Stock only shows once an in-stock style is in that collection.
  var backBtn = q('[data-flag="back"]');
  if (backBtn) backBtn.hidden = !P.some(FLAG_TEST.back);

  function bubbles(p, g){
    var list = sibs(g);
    if (list.length < 2) return '<div class="vdots vdots-empty"></div>';
    var shown = list.slice(0, 5), more = list.length - shown.length;
    if (shown.indexOf(p) === -1) shown[4] = p;
    return '<div class="vdots" role="group" aria-label="Other styles in ' + esc(g) + '">' + shown.map(function(o){
      return '<button type="button" class="vd' + (o === p ? " is-on" : "") + (o.s ? " is-out" : "") + '" data-swap="' + o._i +
        '" aria-pressed="' + (o === p) + '" aria-label="' + esc(o.t) + '" title="' + esc(o.t) + '" style="background-image:url(' + o.i + ')"></button>';
    }).join("") + (more > 0 ? '<span class="vmore">+' + more + '</span>' : "") + '</div>';
  }
  function card(p, g){
    g = g || groupOf(p);
    // Photo slider (snippets/alm-card.liquid markup, assets/alm-cards.js
    // behaviour): first two photos lazy, the rest load on first touch/hover.
    var pics = [p.i].concat(p.i2 ? [p.i2] : [], p.i2 ? p.im : []), n = pics.length;
    var slides = pics.map(function(src, k){
      return '<img class="ci' + (k ? " cs-s" : " ci1") + '" ' + (k < 2 ? 'loading="lazy" src' : 'data-src') + '="' + esc(src) + '" alt="' + (k ? "" : esc(p.t)) + '">';
    }).join("");
    var second = n > 1
      ? '<img class="ci ci2" loading="lazy" src="' + p.i2 + '" alt="" aria-hidden="true">' +
        '<span class="cs-arw cs-prev" role="button" tabindex="-1" data-cs-go="-1" aria-label="Previous photo"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg></span>' +
        '<span class="cs-arw cs-next" role="button" tabindex="-1" data-cs-go="1" aria-label="Next photo"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg></span>' +
        '<span class="cs-bar" aria-hidden="true"><i></i></span>'
      : "";
    var action = p.s
      ? '<span class="notify">Notify Me When Back</span>'
      : '<span class="plus" role="button" tabindex="0" data-ql="' + p._i + '" aria-label="Quick add ' + esc(p.t) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg></span>';
    return '<div class="cardwrap" data-g="' + esc(g) + '"><a class="card' + (p.s ? " is-out" : "") + '" href="' + p.u + '">' +
      '<figure data-cs style="--cs-n:' + n + '"><div class="cs">' + slides + '</div>' + second +
      flags(p) + action + '</figure>' +
      '<h3>' + esc(p.t) + '</h3><p class="price">' + money(p.p) + '</p></a>' + bubbles(p, g) + '</div>';
  }

  function chips(){
    var out = [];
    function add(kind, key, label){
      out.push('<button type="button" class="chip" data-chip="' + kind + '" data-key="' + esc(key) + '">' +
        esc(label) + ' <span>&times;</span></button>');
    }
    keys(S.cats).forEach(function(k){ add("cat", k, k); });
    keys(S.colors).forEach(function(k){ add("color", k, CMAP[k][1]); });
    keys(S.pats).forEach(function(k){ add("pat", k, PMAP[k][1]); });
    keys(S.cuffs).forEach(function(k){ add("cuff", k, (FMAP[k] || [k, k])[1] + " cuff"); });
    keys(S.themes).forEach(function(k){ add("theme", k, k); });
    keys(S.flags).forEach(function(k){ add("flag", k, FLAG_NAME[k]); });
    if (S.q) out.push('<button type="button" class="chip" data-chip="q" data-key="q">&ldquo;' +
      esc(S.q) + '&rdquo; <span>&times;</span></button>');
    if (out.length) out.push('<button type="button" class="chip is-clear" data-reset="1">Clear all</button>');
    q('[data-chips="a"]').innerHTML = out.join("");
  }

  // Featured, agreed on the Oct 9 call: rank by what shoppers actually buy.
  // Sold out styles sort to the bottom rather than out of the grid. In stock,
  // a new arrival with no sales history yet (a fresh launch) leads, so a drop
  // is not buried on its first day; then units sold in the last 90 days
  // (snippets/alm-rank.liquid, from Shopify Analytics); then styles with no
  // sales data, mostly bundles, in collection order.
  var RANK = window.ALM_RANK || {};
  function units(p){ var r = RANK[(p.u || "").split("/products/")[1]]; return r ? r[1] : -1; }
  function rank(a, b){
    if (!!a.s !== !!b.s) return a.s ? 1 : -1;
    var ua = units(a), ub = units(b);
    // Bundles never carry their own sales data, so they do not count as launches.
    var la = a.n && !a.k && ua < 1, lb = b.n && !b.k && ub < 1;
    if (la !== lb) return la ? -1 : 1;
    if (ua !== ub) return ub - ua;
    return a._i - b._i;
  }

  // Best seller order is Rebuy's live top sellers (client, Oct 18: best seller
  // must match 1:1 on the homepage lane, the Best Sellers page and the Best
  // selling sort). Same request as the homepage lane (alm-rebuy.js, limit 60);
  // the Best Sellers collection's admin order is the fallback without Rebuy.
  function rebuyBest(){
    var rb = window.AlmRebuy;
    if (!rb) return;
    rb.handles("products/top_sellers", { limit: 60 }).then(function(h){
      if (!h || !h.length) return;
      D.bestOrder = h;
      render();
    }, function(){});
  }
  if (window.AlmRebuy) rebuyBest(); else document.addEventListener("DOMContentLoaded", rebuyBest);

  // New Arrivals and Best Sellers follow their collection's order in admin
  // (client, Oct 13: the New sort and the New filter disagreed), the rest by
  // Featured. The New and Best Seller filters on their own use the same order.
  function at(list, p){ var i = (list || []).indexOf(handleOf(p)); return i < 0 ? 1e6 : i; }
  var SORT = "featured";
  var SORTERS = {
    featured: rank,
    best: function(a,b){ if(!!a.s!==!!b.s) return a.s?1:-1; return at(D.bestOrder, a) - at(D.bestOrder, b) || rank(a, b); },
    "new": function(a,b){ if(!!a.s!==!!b.s) return a.s?1:-1; return at(D.newOrder, a) - at(D.newOrder, b) || rank(a, b); },
    "price-asc": function(a,b){ if(!!a.s!==!!b.s) return a.s?1:-1; return a.p-b.p; },
    "price-desc": function(a,b){ if(!!a.s!==!!b.s) return a.s?1:-1; return b.p-a.p; },
    name: function(a,b){ if(!!a.s!==!!b.s) return a.s?1:-1; return a.t.localeCompare(b.t); }
  };

  // One page: any ?page=N (old links, the server's past-250 links) is dropped.
  // A filtered landing (Hats, Best Sellers...) holds all of Shop All; once its
  // filter is off, the address bar and title say Shop All too.
  var HOME = location.pathname, HOME_T = document.title.split(" – ")[0], LAND = null;
  function landOn(){ return !LAND || !!S[LAND[0]][LAND[1]]; }
  function basePath(){ return D.all && !landOn() ? D.all.u : HOME; }
  function pageUrl(){
    var u = new URL(location.href);
    u.pathname = basePath();
    u.searchParams.delete("page");
    return u.pathname + u.search + u.hash;
  }

  function render(){
    var by = SORT, fk = keys(S.flags).join();
    if (by === "featured" && (fk === "new" || fk === "best")) by = fk;
    var list = P.filter(match).slice().sort(SORTERS[by] || rank);
    if (pageUrl() !== location.pathname + location.search + location.hash) history.replaceState(history.state, "", pageUrl());
    var tp = document.title.split(" \u2013 ").filter(function(x){ return !/^Page \d+$/.test(x); });
    if (D.all) tp[0] = landOn() ? HOME_T : D.all.t;
    document.title = tp.join(" \u2013 ");
    var shown = list;
    var pg = q('[data-pager="a"]'); if (pg) pg.innerHTML = "";
    q('[data-grid="a"]').innerHTML = list.length
      ? shown.map(function(p){ return card(p); }).join("")
      : '<div class="empty"><p>No socks match that combination.</p>' +
        '<small>Try fewer letters, or clear a filter.</small>' +
        '<button type="button" data-reset="1" style="border:1px solid currentColor;padding:9px 16px;background:none;cursor:pointer;font-size:12px;font-family:inherit">Reset filters</button></div>';
    q('[data-count="a"]').textContent = list.length + (list.length === 1 ? " style" : " styles");
    var dc = q('[data-done-count]'); if (dc) dc.textContent = "Show " + list.length + (list.length === 1 ? " style" : " styles");
    chips();
    Array.prototype.forEach.call(document.querySelectorAll("[data-col]"), function(el){
      var bag = el.dataset.colkind === "cat" ? S.cats : S.themes;
      el.setAttribute("aria-pressed", !!bag[el.dataset.col]);
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-flag]"), function(el){
      el.setAttribute("aria-pressed", !!S.flags[el.dataset.flag]);
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-p]"), function(el){
      el.setAttribute("aria-pressed", !!S.pats[el.dataset.p]);
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-cf]"), function(el){
      el.setAttribute("aria-pressed", !!S.cuffs[el.dataset.cf]);
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-c]"), function(el){
      el.setAttribute("aria-pressed", !!S.colors[el.dataset.c]);
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-t]"), function(el){
      el.setAttribute("aria-pressed", !!S.themes[el.dataset.t]);
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-cat]"), function(el){
      var on = !!S.cats[el.dataset.cat];
      el.setAttribute("aria-pressed", on);
      el.setAttribute("aria-expanded", on);
      var subs = el.parentNode.querySelector(".subs");
      if (subs) subs.hidden = !on;
    });
  }

  q('[data-colors="a"]').innerHTML = COLORS.map(function(c){
    var lbl = c[1];
    return '<button class="swatch" type="button" data-c="' + c[0] + '" aria-pressed="false" aria-label="' + lbl + '">' +
      '<span class="cc" style="background:' + c[2] + '"></span>' + c[1] + '</button>';
  }).join("");

  // Cuff picker: a photo of each style's top edge, so the shopper sees what
  // crew, ruffle and scallop mean before choosing.
  var cuffBox = q('[data-cuffs="a"]');
  if (cuffBox) cuffBox.innerHTML = CUFFS.map(function(c){
    return '<button class="cuff" type="button" data-cf="' + esc(c[0]) + '" aria-pressed="false"><span class="cuff-img"><img src="' + esc(c[2]) + '" alt="" loading="lazy"></span>' + esc(c[1]) + '</button>';
  }).join("");

  // The collection grid the shopper meets before any individual style.
  q('[data-colstrip="a"]').innerHTML = (D.collections || []).map(function(c){
    return '<button class="colcard" type="button" data-col="' + esc(c.t) + '" data-colkind="' + (c.k || "theme") + '" aria-pressed="false">' +
      '<span class="ca"><img loading="lazy" src="' + c.i + '" alt="' + esc(c.t) + ' collection"></span>' +
      '<b>' + esc(c.t) + '</b></button>';
  }).join("");

  // Flat list, no sub-categories: a shopper picking Socks wants socks, not a
  // second decision. COMING carries the two lines that are not on the store yet,
  // so they read as dated rather than as an empty filter.
  var COMING = D.coming || [];
  q('[data-themes="a"]').innerHTML = CATS.map(function(c){
    return '<li><button class="cat" type="button" data-cat="' + esc(c) + '" aria-pressed="false">' +
      esc(c) + '</button></li>';
  }).join("") + COMING.map(function(c){
    return '<li><button class="cat is-soon" type="button" disabled aria-disabled="true">' +
      esc(c[0]) + ' <span>' + esc(c[1]) + '</span></button></li>';
  }).join("");


  var sortEl = q('[data-sort="a"]');
  if (sortEl) sortEl.addEventListener("change", function(e){ SORT = e.target.value; render(); });
  // Quick look drawer: photos, the collection's other styles as the variant
  // pick, add to bag, and an upsell row from the same collection.
  var QL = q("#almQuick"), QLS = q("[data-ql-close]"), qlBody = q("[data-ql-body]"), lastFocus = null;
  function qlRender(p){
    window.__almQl = p;
    // You may also like: the same group and category first (hats for a hat),
    // then the same category, the rest of the group, then the Best Seller tags.
    var g = groupOf(p), ups = [], byRank = P.slice().sort(rank);
    [function(o){ return groupOf(o) === g && o.cat === p.cat; }, function(o){ return o.cat === p.cat; },
     function(o){ return groupOf(o) === g; }, function(o){ return o.bt; }].forEach(function(f){
      byRank.forEach(function(o){ if (ups.length < 4 && o !== p && !o.s && !o.gc && ups.indexOf(o) === -1 && f(o)) ups.push(o); });
    });
    var pics = [p.i].concat(p.i2 ? [p.i2] : []);
    var vars = sibs(g);
    qlBody.innerHTML =
      '<button type="button" class="ql-x" data-ql-close aria-label="Close quick look">&times;</button>' +
      '<div class="ql-pics">' + pics.map(function(src, k){ return '<img src="' + src + '" alt="' + (k ? "" : esc(p.t)) + '">'; }).join("") + '</div>' +
      '<div class="ql-info">' + (tag(p) ? '<span class="flag' + (p.n ? " is-new" : "") + '">' + tag(p) + '</span>' : "") +
      '<h2>' + esc(p.t) + '</h2><p class="ql-price">' + money(p.p) + '</p>' +
      (vars.length > 1 ? '<p class="ql-lbl">More from ' + esc(g) + '</p><div class="ql-vars">' + vars.map(function(o){
        return '<button type="button" class="vd' + (o === p ? " is-on" : "") + (o.s ? " is-out" : "") + '" data-qlswap="' + o._i + '" aria-pressed="' + (o === p) + '" aria-label="' + esc(o.t) + (o.s ? ", sold out" : "") + '" title="' + esc(o.t) + '" style="background-image:url(' + o.i + ')"></button>';
      }).join("") + '</div>' : "") +
      (p.sz ? '<p class="ql-size">' + esc(p.sz) + '</p>' : "") +
      '<div class="ql-buy"><div class="qty" aria-label="Quantity"><button type="button" data-qty="-1" aria-label="Fewer">&minus;</button><span data-qty-n>1</span><button type="button" data-qty="1" aria-label="More">+</button></div>' +
      '<button type="button" class="ql-add" data-qladd>Add to Cart</button></div>' +
      '<a class="ql-full" href="' + p.u + '">View full details</a>' +
      (ups.length ? '<div class="ql-ups"><p class="ql-lbl">You may also like</p><div class="ql-uprow">' + ups.map(function(o){
        return '<div class="ql-up"><div class="ql-upfig"><a href="' + o.u + '"><img src="' + o.i + '" alt="' + esc(o.t) + '"></a><button type="button" class="ql-upadd" data-upadd="' + o._i + '" aria-label="Add ' + esc(o.t) + ' to cart"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg></button></div><b>' + esc(o.t) + '</b><span>' + money(o.p) + '</span></div>';
      }).join("") + '</div></div>' : "") + '</div>';
    // Every product photo, not only the two the grid carries (assets/alm-cards.js).
    if (window.AlmCards && AlmCards.pics) AlmCards.pics(qlBody.querySelector(".ql-pics"), handleOf(p).split("?")[0], p.t);
  }
  function handleOf(p){ return (p.u || "").split("/products/")[1] || p.t; }
  var kindOf = function(p){ var t=(p.th||[]).join(" "); if (/Bamboo/.test(t)) return "Non-grip sock"; return {Socks:"Grip sock",Bundles:"Bundle",Hats:"Hat",Totes:"Tote"}[p.cat] || "Grip sock"; };
  function cartItems(){ return P.map(function(p){ return {h:handleOf(p), v:p.v, t:p.t, p:Math.round(p.p * 100), i:p.i, g:groupOf(p), k:kindOf(p), s:!!p.s, b:!!p.b}; }); }
  if (window.AlmCart) AlmCart.register(cartItems());
  else document.addEventListener("DOMContentLoaded", function(){ if (window.AlmCart) AlmCart.register(cartItems()); });
  function qlOpen(p){
    lastFocus = document.activeElement;
    qlRender(p);
    QL.classList.add("is-open"); QL.setAttribute("aria-hidden", "false"); QLS.hidden = false;
    document.documentElement.classList.add("ql-lock");
    var x = QL.querySelector(".ql-x"); if (x) x.focus();
  }
  function qlClose(){
    QL.classList.remove("is-open"); QL.setAttribute("aria-hidden", "true"); QLS.hidden = true;
    document.documentElement.classList.remove("ql-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var ROOT = q("#opt-a");
  function filters(on){ ROOT.classList.toggle("flt-open", on); document.documentElement.classList.toggle("ql-lock", on); }
  document.addEventListener("keydown", function(e){
    if (e.key === "Escape"){ if (QL.classList.contains("is-open")) qlClose(); filters(false); }
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches("[data-ql],[data-quick]")){ e.preventDefault(); e.target.click(); }
  });
  q('[data-search="a"]').addEventListener("input", function(e){
    S.q = e.target.value.trim().toLowerCase();
    render();
  });

  document.addEventListener("click", function(e){
    // Quick action sits inside the product link, so it must not navigate.
    if (e.target.closest("[data-filters-open]")){ filters(true); return; }
    if (e.target.closest("[data-filters-close]")){ filters(false); return; }
    if (e.target.closest("[data-ql-close]")){ qlClose(); return; }
    var qo = e.target.closest("[data-ql]");
    if (qo){ e.preventDefault(); qlOpen(P[+qo.dataset.ql]); return; }
    var qs = e.target.closest("[data-qlswap]");
    if (qs){ qlRender(P[+qs.dataset.qlswap]); return; }
    var qn = e.target.closest("[data-qty]");
    if (qn){ var n = q("[data-qty-n]"), v = Math.max(1, (+n.textContent) + (+qn.dataset.qty)); n.textContent = v; return; }
    if (e.target.closest("[data-qladd]")){ var b = e.target.closest("[data-qladd]"); b.textContent = "Added to Cart"; b.classList.add("is-done");
      // Add the quick-look style and hand off to the shared cart drawer.
      var qp = window.__almQl, qn2 = q("[data-qty-n]");
      if (window.AlmCart && qp){ qlClose(); AlmCart.add(handleOf(qp), qn2 ? +qn2.textContent : 1); }
      return; }
    if (e.target.closest("[data-upadd]")){ var u = e.target.closest("[data-upadd]"); u.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>'; u.setAttribute("aria-label", "Added to cart"); u.classList.add("is-done");
      // Upsells stay inside the quick look: they join the bag without opening the drawer.
      if (window.AlmCart && P[+u.dataset.upadd]) AlmCart.add(handleOf(P[+u.dataset.upadd]), 1, true);
      return; }
    var sw = e.target.closest("[data-swap]");
    if (sw){
      var wrap = sw.closest(".cardwrap"), np = P[+sw.dataset.swap];
      var tmp = document.createElement("div"); tmp.innerHTML = card(np, wrap.dataset.g);
      wrap.parentNode.replaceChild(tmp.firstChild, wrap);
      return;
    }
    var qa = e.target.closest("[data-quick]");
    if (qa){
      e.preventDefault();
      qa.textContent = qa.dataset.quick === "notify" ? "We will email you" : "Added";
      return;
    }
    var col = e.target.closest("[data-col]");
    if (col){
      // Hats and Totes are product categories, not themes, so the tile drives
      // whichever facet actually holds that collection. One tile at a time
      // (client, Oct 13): another tile replaces it, the same tile clears it.
      var bag = col.dataset.colkind === "cat" ? S.cats : S.themes, was = !!bag[col.dataset.col];
      (D.collections || []).forEach(function(c){ delete S[c.k === "cat" ? "cats" : "themes"][c.t]; });
      bag[col.dataset.col] = !was;
      render();
      var g = q('[data-grid="a"]');
      if (g) g.scrollIntoView({ behavior:"smooth", block:"start" });
      return;
    }
    var fl = e.target.closest("[data-flag]");
    if (fl && !fl.disabled){ S.flags[fl.dataset.flag] = !S.flags[fl.dataset.flag]; return render(); }
    var cfb = e.target.closest("[data-cf]");
    if (cfb){ S.cuffs[cfb.dataset.cf] = !S.cuffs[cfb.dataset.cf]; return render(); }
    var pat = e.target.closest("[data-p]");
    if (pat){ S.pats[pat.dataset.p] = !S.pats[pat.dataset.p]; return render(); }
    var ch = e.target.closest("[data-chip]");
    if (ch){
      var k = ch.dataset.key, kind = ch.dataset.chip;
      if (kind === "q"){ S.q = ""; q('[data-search="a"]').value = ""; }
      else if (kind === "color") delete S.colors[k];
      else if (kind === "pat") delete S.pats[k];
      else if (kind === "cuff") delete S.cuffs[k];
      else if (kind === "theme") delete S.themes[k];
      else if (kind === "flag") delete S.flags[k];
      else if (kind === "cat"){ delete S.cats[k]; subsOf(k).forEach(function(t){ delete S.themes[t]; }); }
      return render();
    }
    var c = e.target.closest("[data-c]");
    if (c){ S.colors[c.dataset.c] = !S.colors[c.dataset.c]; return render(); }
    var t = e.target.closest("[data-t]");
    if (t){ S.themes[t.dataset.t] = !S.themes[t.dataset.t]; return render(); }
    var g = e.target.closest("[data-cat]");
    if (g){
      var name = g.dataset.cat, on = !S.cats[name];
      S.cats[name] = on;
      // collapsing a category drops the subcategories it was holding
      if (!on) subsOf(name).forEach(function(t){ delete S.themes[t]; });
      return render();
    }
    if (e.target.closest("[data-reset]")){
      S = { q:"", colors:{}, pats:{}, themes:{}, cats:{}, flags:{}, cuffs:{} };
      q('[data-search="a"]').value = "";
      return render();
    }
  });

  // Arriving on a collection that has a tile in the strip preselects it, so
  // /collections/happy-hour opens filtered to Cocktails rather than to everything.
  if (D.current){
    var cur = (D.collections || []).filter(function(c){ return c.h === D.current; })[0];
    if (cur) LAND = [cur.k === "cat" ? "cats" : "themes", cur.t];
    // The menu's New / Best Sellers / Bundles / Back in Stock links preselect that label.
    var fk = D.current === D.newHandle ? "new" : D.current === D.bestHandle ? "best" : D.current === D.bundleHandle ? "bundle" : D.current === D.backHandle ? "back" : "";
    if (!cur && fk && D.all) LAND = ["flags", fk];
    if (LAND) S[LAND[0]][LAND[1]] = true;
  }
  render();
  // Landing on a tile that sits off to the side of the strip (e.g. Hats from
  // the menu) scrolls the strip so the chosen tile is in view.
  if (LAND && LAND[0] !== "flags"){
    var onTile = document.querySelector('.colcard[aria-pressed="true"]');
    var strip = onTile && onTile.parentElement;
    while (strip && strip.scrollWidth <= strip.clientWidth + 1) strip = strip.parentElement;
    if (onTile && strip && strip !== document.body){
      var sr = strip.getBoundingClientRect(), tr = onTile.getBoundingClientRect();
      if (tr.left < sr.left || tr.right > sr.right) strip.scrollLeft += tr.left - sr.left - (sr.width - tr.width) / 2;
    }
  }
  window.addEventListener("popstate", function(){
    // Back to the landing URL brings its filter back with it.
    if (LAND && D.all) S[LAND[0]][LAND[1]] = location.pathname !== D.all.u;
    render();
  });
  }
})();
